import { AxiosRequestConfig } from 'axios';
import {
  IFactoringIntegrations,
  INamedCompanies,
  IOtherCompanies,
  OrderFactoredStatus
} from '../../redux/api/factoring/factoring.model';
import api, { apiFactoring, twUrl } from '../../utils/api';
import {
  InvoiceCreateData,
  InvoiceResponseV2,
  InvoiceResponseV3
} from '../Invoices/Invoices.model';
import { FactoringCompany } from '../User/User.model';

class FactoringService {
  /**
   * POST a new factoring config
   */
  static postConfig(
    divisionId: string,
    data: INamedCompanies | IOtherCompanies | null
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const apiResponse = apiFactoring.post(twUrl.factoring.config, data, {
        params: { divisionId }
      });

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
  /**
   * GET a factoring config by divisionID
   */
  static getConfig(divisionId: string, config?: AxiosRequestConfig): Promise<INamedCompanies> {
    return new Promise((resolve, reject) => {
      const apiResponse = apiFactoring.get(twUrl.factoring.config, {
        ...config,
        params: { divisionId }
      });

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response);
        });
    });
  }
  /**
   * DELETE a factoring config
   */
  static deleteConfig(divisionId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const apiResponse = apiFactoring.delete(twUrl.factoring.config, { params: { divisionId } });

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
  /**
   * POST will trigger the export of invoices for a load/order.
   */
  static postExport(
    data: InvoiceCreateData | InvoiceResponseV3 | InvoiceResponseV3[],
    download?: boolean
  ): Promise<{ message: string; createdInvoices: InvoiceResponseV2[] }> {
    return new Promise((resolve, reject) => {
      const url = download ? `${twUrl.factoring.export}?download=true` : twUrl.factoring.export;
      const apiResponse = apiFactoring.post(url, data);

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
  /**
   * GET all factoring companies a user can factor to via SFTP integration.
   */
  static getIntegrations(): Promise<IFactoringIntegrations[]> {
    return new Promise((resolve, reject) => {
      const apiResponse = apiFactoring.get(twUrl.factoring.integrations);

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
  /**
   * GET get the status of a load(s) factoring.
   */
  static getOrderStatus(
    divisionId: string,
    orderIds: string[],
    config?: AxiosRequestConfig
  ): Promise<OrderFactoredStatus[]> {
    const orderIdsParams = orderIds.map((id) => `orderId=${id}`).join('&');
    const params = `divisionId=${divisionId}&${orderIdsParams}`;

    return new Promise((resolve, reject) => {
      const apiResponse = apiFactoring.get(`${twUrl.factoring.status}?${params}`, config);

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response?.data);
        });
    });
  }

  static getInternalFactoringCompany(
    divisionId: string,
    config?: AxiosRequestConfig
  ): Promise<{ data: FactoringCompany }> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.factoring.internalFactoring(divisionId), config);

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
}

export default FactoringService;
